export const FETCH_REQUEST = 'LEADS/FETCH_REQUEST';
export const FETCH_SUCCESS = 'LEADS/FETCH_SUCCESS';
export const FETCH_FAILURE = 'LEADS/FETCH_FAILURE';

export const ASSIGN_REQUEST = 'LEADS/PATCH_ASSIGNEE_REQUEST';
export const ASSIGN_SUCCESS = 'LEADS/PATCH_ASSIGNEE_SUCCESS';
export const ASSIGN_FAILURE = 'LEADS/PATCH_ASSIGNEE_FAILURE';

export const SET_STATUS_REQUEST = 'LEADS/PATCH_STATUS_REQUEST';
export const SET_STATUS_SUCCESS = 'LEADS/PATCH_STATUS_SUCCESS';
export const SET_STATUS_FAILURE = 'LEADS/PATCH_STATUS_FAILURE';

export const DELETE_LEAD_REQUEST = 'LEADS/DELETE_REQUEST';
export const DELETE_LEAD_SUCCESS = 'LEADS/DELETE_SUCCESS';
export const DELETE_LEAD_FAILURE = 'LEADS/DELETE_FAILURE';

export const CREATE_DM_REQUEST = 'LEADS/POST_DIRECT_MESSAGE_REQUEST';
export const CREATE_DM_SUCCESS = 'LEADS/POST_DIRECT_MESSAGE_SUCCESS';
export const CREATE_DM_FAILURE = 'LEADS/POST_DIRECT_MESSAGE_FAILURE';

export const SET_LEADS_FILTER = 'LEADS/SET_FILTER';
export const SET_LEADS_FILTERS = 'LEADS/SET_FILTERS';
export const CLEAR_LEADS_FILTERS = 'LEADS/CLEAR_FILTERS';
export const REMOVE_LEADS_FILTER = 'LEADS/REMOVE_FILTER';

export const SET_INTERVENTION_FILTERS = 'LEADS/INTERVENTION/SET_FILTERS';

export const OPEN_ASSIGN_MODAL = 'LEADS/MODAL/ASSIGN/OPEN';
export const CLOSE_ASSIGN_MODAL = 'LEADS/MODAL/ASSIGN/CLOSE';
export const OPEN_CREATE_DM_MODAL = 'LEADS/MODAL/CREATE_DM/OPEN';
export const CLOSE_CREATE_DM_MODAL = 'LEADS/MODAL/CREATE_DM/CLOSE';
export const PERSISTED_ACTION_TYPES = [SET_LEADS_FILTER, SET_LEADS_FILTERS, CLEAR_LEADS_FILTERS, REMOVE_LEADS_FILTER];
